module.exports = __webpack_public_path__ + "img/3.8252aad2.png";